<template>
  <component :is="tag" v-bind="$attrs" :disabled="active === undefined" @click.stop="onClick">
    <template #icon>
      <slot name="icon"></slot>
    </template>

    <slot v-if="active" name="on"></slot>
    <slot v-if="!active" name="off"></slot>
    <slot></slot>
  </component>
</template>

<script>
  /* eslint-disable vue/no-unused-components */

  import IconButton from '@/Atoms/IconButton';
  import IconLink from '@/Atoms/IconLink';

  export default {
    name: 'ToggleButton',

    components: {
      IconButton,
      IconLink,
    },

    props: {
      tag: {
        type: String,
        default: 'icon-button',
      },
      onActivate: Function,
      onDeactivate: Function,
      isActive: Boolean,
    },

    computed: {
      active: {
        get() {
          return this.isActive;
        },

        set(value) {
          this.$emit('update:isActive', value);
        },
      },
    },

    methods: {
      async onClick(event) {
        if (this.active) {
          this.active = false;
          await this.onDeactivate(event);
        } else {
          this.active = true;
          await this.onActivate(event);
        }
      },
    },
  };
</script>

<style scoped></style>
